import { tableMemory } from "../../Objects/Memory/Memory"
import { Tables } from "../../Objects/Table/Tables"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"

export const useGetTables = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetTable = async (onSuccess: any) => {
    enableLoad()
    try {
      const response = await GetRequest<Tables[]>(API_ROUTES.TABLE.GET_ALL)

      if (response.success) {
        const temp = response.data?.map((ss) => new Tables(ss)) ?? []

        tableMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetTable,
  }
}
